import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import { FaSearch, FaAngleDoubleRight, FaArrowLeft, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";

import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useLocation } from 'react-router-dom';
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { formatBonusAmount } from '../parseWalletAmount.js';
import { FormatDate } from '../Function';

import { Link } from "react-router-dom";

function Index() {
  const [productcategorydata, setproductcategorydata] = useState([]);
  const { user, fulluser } = useContext(AuthContext);

  const [data, setdata] = useState([]);
  const [referredUsers, setReferredUsers] = useState([]);


  const location = useLocation();

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Optionally, clear all inline styles (use with caution)
    // document.body.removeAttribute("style");
  }, [location]);

  const goBack = () => {
    window.history.back(); // Goes back to the previous page
  };

  useEffect(() => {
    getUserdetails();
  }, [user]);

  const getUserdetails = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/allReferral", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          console.log(res.data.wallet);
          if (res.data.status == 'success') {
            setdata(res.data.wallet);
            setReferredUsers(res.data.referred_users || []);
          } else {

          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };


  return (
    <div><div className="min-vh-100">
      {/* Navbar */}
      <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> Referral welcome bonus</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
      </Navbar>
      <div className="row justify-content-center mt-2 p-2">
        <h4 className="text-white mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>My Referral Bonuses</h4>
        {data.length > 0 ? (
          data.map((shop, index) => (
            <div className="col-12 p-1" key={`bonus-${index}`}>
              <Card className="referral-card shadow-sm border-0">
                <Card.Body className="p-3">
                  <div className='row align-items-center'>
                    <div className='col-3 text-center'>
                      {shop.slug === 'ref_bonus' ?
                        <img src={'./exchanging.png'} className="shoplist_img" style={{ maxWidth: '100%', height: 'auto' }} />
                        :
                        <img src={'./budgeting.png'} className="shoplist_img" style={{ maxWidth: '100%', height: 'auto' }} />
                      }
                    </div>
                    <div className='col-9'>
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h4 className="mb-1" style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>Rs. {formatBonusAmount(shop)}</h4>
                          <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>Type: {shop.slug}</p>
                          <p className="text-muted mb-0" style={{ fontSize: '0.75rem' }}>{FormatDate(shop.created_at)}</p>
                        </div>
                        <span className="badge bg-success">Received</span>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))
        ) : (
          <div className="text-center p-4 text-white-50">No bonuses yet</div>
        )}

        <h4 className="text-white mt-4 mb-2" style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>My Referrals</h4>
        {referredUsers && referredUsers.length > 0 ? (
          referredUsers.map((user, index) => (
            <div className="col-12 p-1" key={`user-${index}`}>
              <Card className="referral-card shadow-sm border-0">
                <Card.Body className="p-3">
                  <div className='row align-items-center'>
                    <div className='col-3 text-center'>
                      <div className="bg-primary rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                        <span className="text-white fw-bold">{user.username.charAt(0).toUpperCase()}</span>
                      </div>
                    </div>
                    <div className='col-9'>
                      <h4 className="mb-1" style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>{user.username}</h4>
                      <p className="text-muted mb-1" style={{ fontSize: '0.9rem' }}>Phone: {user.phone}</p>
                      <p className="text-muted mb-0" style={{ fontSize: '0.75rem' }}>Member since: {FormatDate(user.created_at)}</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))
        ) : (
          <div className="text-center p-4 text-white-50">You haven't referred anyone yet</div>
        )}
      </div>
    </div>
    </div>
  )
}
export default Index